export default {
  CART_CLEAR: 'CART_CLEAR',
  CART_LOAD_START: 'CART_LOAD_START',
  CART_LOAD_SUCCESS: 'CART_LOAD_SUCCESS',
  CART_LOAD_FAIL: 'CART_LOAD_FAIL',
  CART_CHANGED_EXTERNALLY: 'CART_CHANGED_EXTERNALLY',
  INCREMENT_PENDING_OPERATION_RELOAD_ATTEMPTS:
    'INCREMENT_PENDING_OPERATION_RELOAD_ATTEMPTS',
  RESET_PENDING_OPERATION_RELOAD_ATTEMPTS:
    'RESET_PENDING_OPERATION_RELOAD_ATTEMPTS',
};
